module.exports = __webpack_public_path__ + "static/img/cp_icon_B04.6ba7ce3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/cp_icon_B04.png
// module id = bzU5
// module chunks = 1